import {
  ApplicationUserEdit,
  DownloadNationalCard,
  DownloadPassport,
} from "store/api/profile";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  styled,
} from "@mui/material";

import { CheckSmall } from "assets/Icon";
import { DefaultUrlApi } from "config/Configuration";
import FileSaver from "file-saver";
import LinearProgressWithLabel from "./LinearProgressWithLabel";
import { LoadingButton } from "@mui/lab";
import http from "config/http";
import theme from "config/theme/theme";
import useNotify from "hooks/useNotify";
import { useSelector } from "react-redux";
import { useState } from "react";

export default function SendFile() {
  const profile = useSelector((state) => state.user?.user?.data);

  const [percentCompleted, setPercentCompleted] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingPassport, setLoadingPassport] = useState(false);
  const [loadingNationalCart, setLoadingNationalCart] = useState(false);

  const [nationalCard, setNationalCard] = useState();
  const [passport, setPassport] = useState();

  const notify = useNotify();

  const changeHandlerNational = (event) => {
    setNationalCard(event.target.files[0]);
  };

  const changeHandlerPassport = (event) => {
    setPassport(event.target.files[0]);
  };

  const config = {
    onUploadProgress: function (progressEvent) {
      setPercentCompleted(
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      );
    },
  };

  const uploadFiles = async () => {
    try {
      setLoading(true);
      const body = new FormData();
      if (nationalCard) body.append(`NationalCard`, nationalCard);
      if (passport) body.append(`Passport`, passport);

      await http.post(DefaultUrlApi + ApplicationUserEdit, body, config);

      setPassport(null);
      setNationalCard(null);

      notify("ارسال فایل با موفقیت انجام شد", "success");
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
    setLoading(false);
  };

  const handleDownloadPassport = async (name) => {
    try {
      await http.get(DownloadPassport, { responseType: "blob" }).then((res) => {
        const result = new Blob([res.data]);

        FileSaver.saveAs(result, profile?.passportName);
      });
    } catch (e) {
      notify(e?.response?.data?.message || "مشکلی پیش آمده است", "error");
    }
    setLoadingPassport(false);
  };

  const handleDownloadNationalCart = async () => {
    try {
      await http
        .get(DownloadNationalCard, { responseType: "blob" })
        .then((res) => {
          const result = new Blob([res.data]);

          FileSaver.saveAs(result, profile?.nationalCardName);
        });
    } catch (e) {
      notify(e?.response?.data?.message || "مشکلی پیش آمده است", "error");
    }
    setLoadingNationalCart(false);
  };

  return (
    <>
      <Box>
        {profile?.isHaveNationalCard ? (
          <BoxUpload>
            {loadingNationalCart ? (
              <CircularProgress size={15} color="secondary" />
            ) : (
              <ButtonFile variant="contained" component="label">
                دریافت فایل
                <input
                  hidden
                  name={"passportCode"}
                  onClick={handleDownloadNationalCart}
                />
              </ButtonFile>
            )}
            دریافت فایل کارت ملی
          </BoxUpload>
        ) : (
          <BoxUpload>
            <ButtonFile variant="contained" component="label">
              انتخاب فایل
              <input
                hidden
                type="file"
                name={"passportCode"}
                disabled={profile?.isNationalCardConfirmed}
                onChange={changeHandlerNational}
                accept={"image/*"}
              />
            </ButtonFile>
            انتخاب فایل کارت ملی
          </BoxUpload>
        )}

        <Box>
          {nationalCard ? (
            <BoxNationalCard>
              <Typography
                component="span"
                onClick={() => {
                  setNationalCard(undefined);
                }}
              >
                <ion-icon name="close-outline" />
              </Typography>
              <Typography variant="h6">{nationalCard.name}</Typography>
            </BoxNationalCard>
          ) : !profile?.isNationalCardConfirmed ? (
            profile?.nationalCardName && (
              <BoxCheck>
                <CircularProgress size={15} color="secondary" />

                <Typography variant="h6" paddingRight={1}>
                  در حال بررسی
                </Typography>
              </BoxCheck>
            )
          ) : (
            <BoxCheck>
              <CheckSmall color={theme.palette.success.main} />
              <Typography variant="h6" paddingLeft={1} color="success.main">
                تائید شده
              </Typography>
            </BoxCheck>
          )}
        </Box>
      </Box>

      <Box>
        {profile?.isHavePassport ? (
          <BoxUpload>
            {loadingPassport ? (
              <CircularProgress size={15} color="secondary" />
            ) : (
              <ButtonFile variant="contained" component="label">
                دریافت فایل
                <input
                  hidden
                  name={"passportCode"}
                  onClick={handleDownloadPassport}
                />
              </ButtonFile>
            )}
            دریافت فایل پاسپورت
          </BoxUpload>
        ) : (
          <BoxUpload>
            <ButtonFile
              variant="contained"
              component="label"
              onClick={uploadFiles}
            >
              انتخاب فایل
              <input
                hidden
                type="file"
                name={"passportCode"}
                disabled={profile?.isPassportConfirmed}
                onChange={changeHandlerPassport}
                accept={"image/*"}
              />
            </ButtonFile>
            انتخاب فایل پاسپورت
          </BoxUpload>
        )}

        <Box>
          {passport ? (
            <BoxNationalCard>
              <Typography
                component="span"
                onClick={() => {
                  setPassport(undefined);
                }}
              >
                <ion-icon name="close-outline" />
              </Typography>

              <Typography variant="h6">{passport.name}</Typography>
            </BoxNationalCard>
          ) : !profile?.isPassportConfirmed ? (
            profile?.passportName !== "" && (
              <BoxCheck>
                <CircularProgress size={15} color="secondary" />

                <Typography variant="h6" paddingRight={1}>
                  در حال بررسی
                </Typography>
              </BoxCheck>
            )
          ) : (
            <BoxCheck>
              <CheckSmall color={theme.palette.success.main} />
              <Typography variant="h6" paddingLeft={1} color="success.main">
                تائید شده
              </Typography>
            </BoxCheck>
          )}
        </Box>
      </Box>

      {!(profile?.isPassportConfirmed && profile?.isNationalCardConfirmed) && (
        <Box mt={2}>
          {(nationalCard?.name || passport?.name) && (
            <LoadingButton
              loading={loading}
              color="success"
              variant="contained"
              fullWidth
              onClick={uploadFiles}
            >
              ارسال
            </LoadingButton>
          )}

          {percentCompleted > 0 && percentCompleted < 100 && (
            <LinearProgressWithLabel value={percentCompleted} />
          )}
        </Box>
      )}
    </>
  );
}

const BoxNationalCard = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "row-reverse",
  marginBottom: "10px",
  borderRadius: "10px",
  fontSize: "16px",
  height: "50px",
  color: theme.palette.text.secondary,
  span: {
    display: "flex",
  },
}));

const BoxCheck = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row-reverse",
  justifyContent: "right",
  alignItems: "center",
  marginTop: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));

const ButtonFile = styled(Button)(({ theme }) => ({
  minHeight: "0px !important",
  background: "none",
  fontSize: "12px",
  color: theme.palette.secondary.main,
  padding: 0,
}));

const BoxUpload = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  width: "100%",
  textAlign: "right",
  color: theme.palette.text.secondary,
  padding: " 12px 14px",
  borderRadius: "10px",
  display: "flex",
  justifyContent: "space-between",
  marginTop: theme.spacing(2),
}));
